const lidarrGreen = '#00A65B';

module.exports = {
  defaultColor: '#333',
  disabledColor: '#999',
  dimColor: '#555',
  black: '#000',
  white: '#fff',
  offWhite: '#f5f7fa',
  blue: '#06f',
  yellow: '#FFA500',
  primaryColor: '#0b8750',
  selectedColor: '#f9be03',
  successColor: '#27c24c',
  dangerColor: '#f05050',
  warningColor: '#ffa500',
  infoColor: lidarrGreen,
  purple: '#7a43b6',
  pink: '#ff69b4',
  lidarrGreen,
  helpTextColor: '#909293',
  darkGray: '#888',
  gray: '#adadad',
  lightGray: '#ddd',
  disabledInputColor: '#808080',

  // Theme Colors

  themeBlue: lidarrGreen,
  themeAlternateBlue: '#00a65b',
  themeRed: '#c4273c',
  themeDarkColor: '#353535',
  themeLightColor: '#1d563d',

  torrentColor: '#00853d',
  usenetColor: '#17b1d9',

  // Links
  defaultLinkHoverColor: '#fff',
  linkColor: '#0b8750',
  linkHoverColor: '#1b72e2',

  // Sidebar

  sidebarColor: '#e1e2e3',
  sidebarBackgroundColor: '#353535',
  sidebarActiveBackgroundColor: '#252525',

  // Toolbar
  toolbarColor: '#e1e2e3',
  toolbarBackgroundColor: '#1d563d',
  toolbarMenuItemBackgroundColor: '#4D8069',
  toolbarMenuItemHoverBackgroundColor: '#353535',
  toolbarLabelColor: '#8895aa',

  // Accents
  borderColor: '#e5e5e5',
  inputBorderColor: '#dde6e9',
  inputBoxShadowColor: 'rgba(0, 0, 0, 0.075)',
  inputFocusBorderColor: '#66afe9',
  inputFocusBoxShadowColor: 'rgba(102, 175, 233, 0.6)',
  inputErrorBorderColor: '#f05050',
  inputErrorBoxShadowColor: 'rgba(240, 80, 80, 0.6)',
  inputWarningBorderColor: '#ffa500',
  inputWarningBoxShadowColor: 'rgba(255, 165, 0, 0.6)',
  colorImpairedGradient: '#ffffff',
  colorImpairedGradientDark: '#f4f5f6',

  //
  // Buttons

  defaultBackgroundColor: '#fff',
  defaultBorderColor: '#eaeaea',
  defaultHoverBackgroundColor: '#f5f5f5',
  defaultHoverBorderColor: '#d6d6d6;',

  primaryBackgroundColor: '#0b8750',
  primaryBorderColor: '#1d563d',
  primaryHoverBackgroundColor: '#097948',
  primaryHoverBorderColor: '#1D563D;',

  successBackgroundColor: '#27c24c',
  successBorderColor: '#26be4a',
  successHoverBackgroundColor: '#24b145',
  successHoverBorderColor: '#1f9c3d;',

  warningBackgroundColor: '#ff902b',
  warningBorderColor: '#ff8d26',
  warningHoverBackgroundColor: '#ff8517',
  warningHoverBorderColor: '#fc7800;',

  dangerBackgroundColor: '#f05050',
  dangerBorderColor: '#f04b4b',
  dangerHoverBackgroundColor: '#ee3d3d',
  dangerHoverBorderColor: '#ec2626;',

  iconButtonDisabledColor: '#7a7a7a',
  iconButtonHoverColor: '#666',
  iconButtonHoverLightColor: '#ccc',

  //
  // Modal

  modalBackdropBackgroundColor: 'rgba(0, 0, 0, 0.6)',
  modalBackgroundColor: '#fff',
  modalCloseButtonHoverColor: '#888',

  //
  // Menu
  menuItemColor: '#e1e2e3',
  menuItemHoverColor: '#fbfcfc',
  menuItemHoverBackgroundColor: '#f5f7fa',

  //
  // Toolbar

  toobarButtonHoverColor: '#00A65B',
  toobarButtonSelectedColor: '#00A65B',

  //
  // Scroller

  scrollbarBackgroundColor: '#9ea4b9',
  scrollbarHoverBackgroundColor: '#656d8c',

  //
  // Card

  cardShadowColor: '#e1e1e1',
  cardAlternateBackgroundColor: '#f5f5f5',

  //
  // Alert

  alertDangerBorderColor: '#ebccd1',
  alertDangerBackgroundColor: '#f2dede',
  alertDangerColor: '#a94442',

  alertInfoBorderColor: '#bce8f1',
  alertInfoBackgroundColor: '#d9edf7',
  alertInfoColor: '#31708f',

  alertSuccessBorderColor: '#d6e9c6',
  alertSuccessBackgroundColor: '#dff0d8',
  alertSuccessColor: '#3c763d',

  alertWarningBorderColor: '#faebcc',
  alertWarningBackgroundColor: '#fcf8e3',
  alertWarningColor: '#8a6d3b',

  //
  // Slider

  sliderAccentColor: '#0b8750',

  //
  // Form

  advancedFormLabelColor: '#ff902b',
  disabledCheckInputColor: '#ddd',

  //
  // Popover

  popoverTitleBackgroundColor: '#f7f7f7',
  popoverTitleBorderColor: '#ebebeb',
  popoverShadowColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderColor: '#fff',

  popoverTitleBackgroundInverseColor: '#3a3f51',
  popoverTitleBorderInverseColor: '#353535',
  popoverShadowInverseColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderInverseColor: 'rgba(58, 63, 81, 0.75)',

  //
  // Calendar

  calendarTodayBackgroundColor: '#ddd',
  calendarBorderColor: '#cecece',

  //
  // Table

  tableRowHoverBackgroundColor: '#fafbfc'
};
